// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_COMPARE_STROLLER = "porovn\u00e1n\u00ed ko\u010d\u00e1rku";
export const STROLLERS_COMPARISON_REMOVE_ALL_CONFIRM = "Opravdu chce\u0161 odebrat v\u0161echny ko\u010d\u00e1rky z porovn\u00e1v\u00e1n\u00ed";
